<template>
	<div class="nested-content">
		<div v-for="(item, index) in items" :key="itemKey + index" class="nested-item">
			<div v-if="isStringObject(item)" :class="['fontSize14', levelClass]">{{ item }}</div>
			<div v-else>
				<p v-if="item.title" :class="[levelClass, 'item-title']" style="color: var(--mainColor);font-size: 16px;">
					{{ item.title }}
				</p>

				<div v-if="typeof item.content === 'object'" class="content-container">
					<nested-content v-if="Array.isArray(item.content)" :items="item.content" :level="level + 1"
						:item-key="'content-' + itemKey + index" :open-file="openFile" />
					<p v-else :class="['text', levelClass]">{{ item.content }}</p>
				</div>
				<p v-else-if="item.content" :class="['text','fontSize14', levelClass]"
					:style="{'color':item.color?item.color:'#282828'}">{{ item.content }}</p>

				<img v-if="item.image" :class="[levelClass+'img']" :src="imgUrl+item.image" alt="图片" style="width: 50%;">

				<div v-if="item.files && item.files.length > 0" class="fileImgs">
					<p v-for="(file, fileIdx) in item.files" :key="'file-' + itemKey + index + '-' + fileIdx"
						@click="openFile(file)">
						<img :src="require('@/assets/img/tableEntryService/' + getExtension(file) + '.png')" />
						<span>{{ file }}</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'NestedContent',
		props: {
			items: {
				type: Array,
				required: true
			},
			level: {
				type: Number,
				default: 1
			},
			itemKey: {
				type: String,
				default: ''
			},
			openFile: {
				type: Function,
				required: true
			}
		},
		data() {
			return {
				imgUrl: 'https://www.flcccc.com/flow/dataAsset/uploadImg/dataProductDesign/img/'

			}
		},
		methods: {
			isStringObject(data) {
				return typeof data === 'string'
			},
			getExtension(filename) {
				return filename.split('.').pop().toLowerCase()
			}
		},
		computed: {
			levelClass() {
				return `level-${this.level}`
			}
		}
	}
</script>

<style scoped>
	.nested-content {
		margin-bottom: 20px;
	}

	.nested-item {
		margin-bottom: 10px;
	}

	.item-title {
		/* font-weight: bold; */
		margin-bottom: 8px;
	}

	.content-container {
		margin-bottom: 10px;
	}

	.fontSize14 {
		font-size: 14px;
		line-height: 24px;
		color: #282828;
	}

	.level-1 {
		padding-left: 0;
	}

	.level-2 {
		padding-left: 16px;
		line-height: 24px;
	}

	.level-2img {
		margin-left: 16px;
	}

	.level-3,
	.level-3img {
		margin-left: 26px;
	}

	.level-4,
	.level-4img {
		margin-left: 60px;
	}

	.level-5,
	.level-5img {
		margin-left: 80px;
	}

	.text {
		margin-bottom: 10px;
		color: #282828;
	}

	.fileImgs {
		margin-top: 10px;
	}

	.fileImgs p {
		align-items: center;
		cursor: pointer;
		padding: 10px 10px 10px 15px;
		border-radius: 4px;
		transition: all 0.3s;
	}

	.fileImgs p:hover {
		background-color: #e0e0e0;
	}

	.fileImgs img {
		height: 30px;
		margin-right: 10px;
		vertical-align: middle;
	}

	.fileImgs span {
		font-size: 14px;
		color: #282828;
		text-decoration: underline;
	}
</style>